/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import AddAction from './AddAction/index'
import Editor from './Editor/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content"
  
}) {
let questionsValueData = fromData.useDataFormat({ viewPath,
context: 'questions',
format: fromHelpers.useTableRowsData,
})
let onRowClick = fromHelpers.useOnRowClick({
  children,
  viewPath
  
})
let onReorder = fromHelpers.useOnReorder({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<TableX
  viewPath={`${viewPath}/TableX`}
 data="questions"
 format="helpers.js useTableRowsData"
 value={questionsValueData}
 onRowClick={onRowClick}
 onReorder={onReorder}
 enableDragAndDrop={true}
/>
<Editor
  viewPath={`${viewPath}/Editor`}
/>
{children}
</React.Fragment>)
}